import { render } from "./nav.vue?vue&type=template&id=1e3c5113&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"

import "./nav.vue?vue&type=style&index=0&id=1e3c5113&scoped=true&lang=scss"

import exportComponent from "/Users/yangshaohua/work/workspace/school-b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3c5113"]])

export default __exports__